import "./shimmering-disc.css";

export function ShimmeringDisc({ size = 128 }: { size?: number }) {
  return (
    <div className="disc-wrapper" style={{ width: size, height: size }}>
      <img
        src="/cd-disc.png"
        alt="Clubhouse FM"
        className="disc-image"
        draggable={false}
      />
      {/* Sparkle dots */}
      <div className="disc-sparkle sparkle-1" />
      <div className="disc-sparkle sparkle-2" />
      <div className="disc-sparkle sparkle-3" />
    </div>
  );
}
